<template>
  <div>
    <inventory product="GDPR" />
  </div>
</template>
<script>
import inventory from "./inventory";

export default {
  components: { inventory },
};
</script>
